import React from 'react';
import { withTranslation } from 'react-i18next';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import SwipeableViews from 'react-swipeable-views';
import Container from './components/container';
import Logo from './images/brand_stacked.png';
import Captcha from '../../components/captcha';
import styles from './view.module.scss';
import Config from '../../config';

const materialStyles = makeStyles({
  container: {
    display: 'flex',
    width: '100% !important',
  },
  left: {
    width: '50%',
    height: 54,
    padding: '0 30px',
    borderTopLeftRadius: '30px',
    borderBottomLeftRadius: '30px',
  },
  right: {
    width: '50%',
    height: 54,
    borderTopRightRadius: '30px',
    borderBottomRightRadius: '30px',
  },
  consent: {
    '& .MuiCheckbox-colorSecondary.Mui-checked': {
      color: '#424040',
    },
    '& .MuiTypography-body1': {
      fontSize: '0.8rem',
    },
  },
  button: {
    width: '100%',
    height: 54,
    padding: '0 30px',
    borderTopLeftRadius: '30px',
    borderBottomLeftRadius: '30px',
    borderTopRightRadius: '30px',
    borderBottomRightRadius: '30px',
  },
});

function View(props) {
  const {
    presenter,
    consent,
    consentError,
    tab,
    loading,
    errorName,
    errorFqdn,
    upgradeName,
    upgradeFqdn,
    publisherConsent,
    publisherConsentError,
    errorCaptcha,
    token,
    t,
    password,
    errorPassword,
  } = props;
  const material = materialStyles();
  let tabIndex = 0;
  if (tab === 'warning') {
    tabIndex = 1;
  } else if (tab === 'upgrade') {
    tabIndex = 2;
  }

  let message = t('login.message');
  let secondaryMessage = t('login.message_sub');
  if (tab === 'upgrade') {
    message = t('login.upgrade.title');
    secondaryMessage = t('login.upgrade.message');
  }
  return (
    <Container primaryText={message} secondaryText={secondaryMessage}>
      {loading && (
        <div className={styles.form}>
          <div style={{ marginBottom: '40px' }}>
            <img
              ref={(element) => {
                presenter.onIconLoaded(element);
              }}
              style={{ width: '150px' }}
              src={Logo}
              alt=""
            />
          </div>

          <Typography className={styles.loader}>{t('login.loading')}</Typography>
        </div>
      )}
      {!loading && (
        <SwipeableViews
          style={{ width: '100%', height: '100%' }}
          containerStyle={{ width: '100%', height: '100%' }}
          axis="x"
          index={tabIndex}
          onChangeIndex={() => {}}
          disabled
        >
          <div className={styles.formInner}>
            {tab === 'main' && (
              <div className={styles.form}>
                <div style={{ marginBottom: '40px' }}>
                  <img
                    ref={(element) => {
                      presenter.onIconLoaded(element);
                    }}
                    style={{ width: '150px' }}
                    src={Logo}
                    alt=""
                  />
                </div>

                <div style={{ width: '100%' }}>
                  <FormGroup className={styles.consent}>
                    <FormControlLabel
                      className={material.consent}
                      control={(() => {
                        return (
                          <Checkbox
                            checked={consent}
                            onChange={() => presenter.onConsentClick()}
                            name="terms"
                          />
                        );
                      })()}
                      label={(() => {
                        return (
                          <Typography
                            align="left"
                            dangerouslySetInnerHTML={{
                              __html: t('login.terms_privacy', {
                                terms: Config.termsAndConditions,
                                privacy: Config.privacyPolicy,
                              }),
                            }}
                          />
                        );
                      })()}
                    />
                    {consentError && (
                      <FormHelperText>{t('login.terms_privacy_required')}</FormHelperText>
                    )}
                  </FormGroup>
                  <ButtonGroup className={material.container}>
                    <Button className={material.button} onClick={() => presenter.onLoginClick()}>
                      {t('login.button_login_or_signup')}
                    </Button>
                  </ButtonGroup>
                </div>
              </div>
            )}
          </div>
          {tab === 'warning' && (
            <div className={styles.warningForm}>
              <div className={styles.warningInfo}>
                <Typography variant="h4">{t('login.warning.title')}</Typography>
                <Typography
                  className={styles.warningMessage}
                  variant="subtitle1"
                  dangerouslySetInnerHTML={{
                    __html: t('login.warning.message', { token }),
                  }}
                />
              </div>
              <div style={{ flex: 1 }} />
              <div style={{ width: '100%' }}>
                <div className={styles.warningButtonContainer}>
                  <Button
                    variant="outlined"
                    className={styles.button}
                    onClick={() => presenter.onBackClick()}
                  >
                    {t('login.warning.cancel')}
                  </Button>

                  <div className={styles.space} />

                  <Button
                    variant="contained"
                    color="primary"
                    className={styles.warningButton}
                    onClick={() => presenter.onContinueClick()}
                  >
                    {t('login.warning.continue')}
                  </Button>
                </div>
              </div>
            </div>
          )}
          {tab === 'upgrade' && (
            <div className={styles.upgradeForm}>
              <div className={styles.upgradeInfo}>
                <Typography variant="h4">{t('login.upgrade.title')}</Typography>
                <Typography variant="subtitle1">{t('login.upgrade.message')}</Typography>
              </div>
              <TextField
                className={styles.upgradeInput}
                fullWidth
                label={t('login.upgrade.company_name')}
                helperText={t(errorName)}
                value={upgradeName}
                onChange={(event) => {
                  return presenter.onUpgradeNameChange(event.target.value);
                }}
              />
              <TextField
                className={styles.upgradeInput}
                fullWidth
                label={t('login.upgrade.company_fqdn')}
                placeholder={t('login.upgrade.company_fqdn_hint')}
                helperText={t(errorFqdn)}
                value={upgradeFqdn}
                onChange={(event) => {
                  return presenter.onUpgradeFqdnChange(event.target.value);
                }}
              />
              <TextField
                className={styles.upgradeInput}
                fullWidth
                type="password"
                label={t('login.upgrade.password')}
                placeholder={t('login.upgrade.password_hint')}
                helperText={t(errorPassword)}
                value={password}
                onChange={(event) => {
                  return presenter.onPasswordChange(event.target.value);
                }}
              />

              <div style={{ flex: 1 }} />
              <Captcha
                className={styles.captcha}
                onLoad={(reload, id) => presenter.onCaptchaLoad(reload, id)}
              />
              <TextField
                className={styles.captchaInput}
                fullWidth
                label={t('login.upgrade.captcha')}
                helperText={t(errorCaptcha)}
                onChange={(event) => {
                  return presenter.onUpgradeCaptchaChange(event.target.value);
                }}
              />
              <div style={{ width: '100%' }}>
                <FormGroup className={styles.consent}>
                  <FormControlLabel
                    className={material.consent}
                    control={(() => {
                      return (
                        <Checkbox
                          checked={publisherConsent}
                          onChange={() => presenter.onPublisherConsentClick()}
                          name="terms"
                        />
                      );
                    })()}
                    label={(() => {
                      return (
                        <Typography
                          align="left"
                          dangerouslySetInnerHTML={{
                            __html: t('login.upgrade.terms', {
                              terms: Config.publisherTerms,
                            }),
                          }}
                        />
                      );
                    })()}
                  />
                  {publisherConsentError && (
                    <FormHelperText>{t('login.upgrade.terms_required')}</FormHelperText>
                  )}
                </FormGroup>
                <div className={styles.upgradeButtonContainer}>
                  <Button
                    variant="outlined"
                    className={styles.button}
                    onClick={() => presenter.onBackClick()}
                  >
                    {t('login.upgrade.cancel')}
                  </Button>

                  <div className={styles.space} />

                  <Button
                    variant="contained"
                    color="primary"
                    className={styles.upgradeButton}
                    onClick={() => presenter.onUpgradeClick()}
                  >
                    {t('login.upgrade.upgrade')}
                  </Button>
                </div>
              </div>
            </div>
          )}
        </SwipeableViews>
      )}
    </Container>
  );
}

export default withTranslation()(View);
